import React from 'react';

import { css } from '@emotion/react';
import { formatPrice, getFormattedPrice } from 'utils/utils';
import { theme } from 'styles/theme';
import { usePrice } from 'hooks/usePrice';

export const SummaryPrice = ({
	value,
	isVAT,
	showVATCalculation,
	alignRight,
}: {
	value: number;
	isVAT: boolean;
	showVATCalculation: boolean;
	alignRight: boolean;
}) => {
	const { withoutVAT, VAT } = usePrice({ price: value });

	return (
		<div
			css={css`
				${alignRight &&
				css`
					text-align: right;
				`}
			`}
		>
			<strong>
				{getFormattedPrice(value, isVAT)}
				{/* {formatPrice(isVAT ? withVAT : withoutVAT)} {isVAT && ' s DPH'} */}
			</strong>
			{isVAT && showVATCalculation && (
				<>
					<div
						css={css`
							font-size: 13px;
							color: ${theme.color.text['300']};
						`}
					>
						{formatPrice(withoutVAT)} bez DPH
					</div>

					<div
						css={css`
							font-size: 13px;
							color: ${theme.color.text['300']};
						`}
					>
						Z toho DPH {formatPrice(VAT)}
					</div>
				</>
			)}
		</div>
	);
};
